export class FunctionOptions {
    public type: 'callable' | 'request';
    public httpMethod: 'POST' | 'GET' | 'UPDATE' | 'DELETE';

    constructor(type: 'callable' | 'request', httpMethod?: 'POST' | 'GET' | 'UPDATE' | 'DELETE') {
        this.type = type;
        this.httpMethod = httpMethod;
    }
}
